import { useEffect, useState } from 'react';
import api from './api';

// Which modules the company you're working in has switched on (set by Stagehead in Companies).
// Cached per browser tab so the sidebar doesn't flicker, refreshed from /api/auth/me on load.
const KEY = 'sh_modules';
const read = () => { try { const v = sessionStorage.getItem(KEY); return v ? JSON.parse(v) : null; } catch (e) { return null; } };
const write = (mods) => { try { sessionStorage.setItem(KEY, JSON.stringify(mods)); } catch (e) { /* ignore */ } };

let current = read();
let pending = null;
const listeners = new Set();

export const refreshModules = () => {
  if (!pending) {
    pending = api.get('/api/auth/me').then((r) => {
      const mods = r.data?.company?.modules;
      if (Array.isArray(mods)) {
        current = mods;
        write(mods);
        listeners.forEach((fn) => fn(mods));
      }
      return current;
    }).catch(() => current).finally(() => { pending = null; });
  }
  return pending;
};

export const clearModules = () => { current = null; try { sessionStorage.removeItem(KEY); } catch (e) { /* ignore */ } };

// null while unknown (first load in a new tab), then the list
export function useModules() {
  const [mods, setMods] = useState(current);
  useEffect(() => {
    listeners.add(setMods);
    refreshModules();
    return () => listeners.delete(setMods);
  }, []);
  return mods;
}

export const hasModule = (mods, key) => !key || (Array.isArray(mods) && mods.includes(key));
